import { route as categoryC1Route } from "@faire/web-api/routes/category/c1CategoryUrlId";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Hamburger } from "@faire/web/ui/Hamburger";
import { useViewportWidth } from "@faire/web/ui/hooks/useViewportWidth";
import { observer } from "mobx-react";
import React, { Suspense } from "react";

import { useNextPrefetchContext } from "@faire/retailer/app/_lib/routing/NextPrefetchContext";
import { LazyMobileMenu } from "@faire/retailer/components/Header/mobile/MobileMenu";
import { HeaderLinkButton } from "@faire/retailer/components/Header/styled";
import { useHeaderState } from "@faire/retailer/components/Header/useHeaderState";
import { useIsLoggedInRetailer } from "@faire/retailer/lib/isLoggedInRetailer";
import { getSettingAndAssignCatNavTopOfPageSpeedExperiment } from "@faire/retailer/settings/getSettingCatNavTopOfPageSpeedExperiment";

import { topNavEvent } from "../Events";

const HeaderMobileHamburgerMenuBase: React.FC = () => {
  const width = useViewportWidth((width) => width);
  const { strictLocalize } = useStrictLocalization();
  const isLoggedInRetailer = useIsLoggedInRetailer();
  const nextPrefetch = useNextPrefetchContext();
  const { isShowingMenu, hideMenu, showMenu } = useHeaderState();

  const toggleMenu = () => {
    const trackToggleEvent = isShowingMenu
      ? topNavEvent("close")
      : topNavEvent("open");
    if (
      !isShowingMenu &&
      isLoggedInRetailer &&
      getSettingAndAssignCatNavTopOfPageSpeedExperiment()
    ) {
      nextPrefetch(categoryC1Route);
    }
    isShowingMenu ? hideMenu() : showMenu();
    trackToggleEvent();
  };

  return (
    <>
      <HeaderLinkButton
        onClick={toggleMenu}
        $width={width}
        aria-label={strictLocalize({
          defaultMessage: "Menu button",
          description: {
            text: "Aria label for the button to open navigation",
            img: "https://cdn.faire.com/fastly/067a8289eb46d43aa3276e51ef58803df8e1901bf04a10ec0ec0e4aecadd24f2.png",
          },
        })}
      >
        <Hamburger data-test-id="mobile-menu" />
      </HeaderLinkButton>
      {isShowingMenu ? (
        <Suspense fallback={null}>
          <LazyMobileMenu onClose={toggleMenu} />
        </Suspense>
      ) : null}
    </>
  );
};

export const HeaderMobileHamburgerMenu = observer(
  HeaderMobileHamburgerMenuBase
);
